// components/support-types/TicketSupport.js
import React, { useState } from 'react';

const TicketSupport = () => {
  const [ticketForm, setTicketForm] = useState({
    name: '',
    email: '',
    phone: '',
    category: '',
    priority: '',
    subject: '',
    description: ''
  });

  const handleTicketSubmit = (e) => {
    e.preventDefault();
    alert('Support ticket berhasil dibuat! Anda akan menerima email konfirmasi dalam beberapa menit.');
    setTicketForm({
      name: '',
      email: '',
      phone: '',
      category: '',
      priority: '',
      subject: '',
      description: ''
    });
  };

  return (
    <form onSubmit={handleTicketSubmit} className="space-y-6">
      <h3 className="text-2xl font-bold mb-6 flex items-center gap-3">
        🎫 Support Ticket
      </h3>

      {/* Nama & Email */}
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-semibold mb-2">Nama Lengkap *</label>
          <input
            type="text"
            required
            value={ticketForm.name}
            onChange={(e) => setTicketForm({ ...ticketForm, name: e.target.value })}
            className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
            placeholder="Nama Anda"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Email *</label>
          <input
            type="email"
            required
            value={ticketForm.email}
            onChange={(e) => setTicketForm({ ...ticketForm, email: e.target.value })}
            className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
            placeholder="email@domain.com"
          />
        </div>
      </div>

      {/* Phone, Kategori, Prioritas */}
      <div className="grid md:grid-cols-3 gap-6">
        <div>
          <label className="block text-sm font-semibold mb-2">Nomor Telepon</label>
          <input
            type="tel"
            value={ticketForm.phone}
            onChange={(e) => setTicketForm({ ...ticketForm, phone: e.target.value })}
            className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
            placeholder="0812xxxxxxx"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Kategori *</label>
          <select
            required
            value={ticketForm.category}
            onChange={(e) => setTicketForm({ ...ticketForm, category: e.target.value })}
            className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
          >
            <option value="">Pilih Kategori</option>
            <option value="technical">Masalah Teknis</option>
            <option value="billing">Tagihan & Pembayaran</option>
            <option value="account">Akun & Profil</option>
            <option value="content">Konten & Channel</option>
            <option value="other">Lainnya</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Prioritas *</label>
          <select
            required
            value={ticketForm.priority}
            onChange={(e) => setTicketForm({ ...ticketForm, priority: e.target.value })}
            className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
          >
            <option value="">Pilih Prioritas</option>
            <option value="low">Rendah</option>
            <option value="medium">Sedang</option>
            <option value="high">Tinggi</option>
            <option value="urgent">Urgent</option>
          </select>
        </div>
      </div>

      {/* Subject */}
      <div>
        <label className="block text-sm font-semibold mb-2">Subject *</label>
        <input
          type="text"
          required
          value={ticketForm.subject}
          onChange={(e) => setTicketForm({ ...ticketForm, subject: e.target.value })}
          className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
          placeholder="Judul singkat masalah Anda"
        />
      </div>

      {/* Deskripsi */}
      <div>
        <label className="block text-sm font-semibold mb-2">Deskripsi Masalah *</label>
        <textarea
          required
          rows={5}
          value={ticketForm.description}
          onChange={(e) => setTicketForm({ ...ticketForm, description: e.target.value })}
          className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
          placeholder="Jelaskan masalah Anda dengan detail..."
        />
      </div>

      {/* Submit */}
      <button
        type="submit"
        className="w-full bg-purple-600 hover:bg-purple-700 text-white py-4 rounded-xl font-semibold text-lg transition-colors"
      >
        Submit Ticket
      </button>
    </form>
  );
};

export default TicketSupport;